// the red bubble on the Home Screen app icon shows the unread enquiries from the menu, but only on a device that gets
// our notifications
export default async function syncAppBadge(count) {
  if (!('setAppBadge' in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration('/venue-cabinet/');
    const getsNotifications = Boolean(await registration?.pushManager.getSubscription());
    await (getsNotifications && count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge());
  } catch {
    // a bubble that can't be set mustn't break the page
  }
}
